export function deliveryAddressText(slip) {
  if (!slip?.to_address?.trim()) return "";
  return [
    "Deliver To",
    slip.to_name?.trim(),
    slip.to_address.trim(),
    [slip.to_city, slip.to_state, slip.to_pincode].map((part) => part?.trim()).filter(Boolean).join(", "),
    slip.to_phone?.trim() ? `Phone: ${slip.to_phone.trim()}` : "",
  ].filter(Boolean).join("\n");
}